import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import Form from '@platform/form';
import { Button } from '@platform/base';
import { getSysFieldid, getSafeRandom, microAppUtil } from '@platform/api';
import BaseCardTable from './BaseCardTable';
import {
    handleBeforeEvent,
    handleAfterEvent,
} from '../../utils';
import classNames from 'classnames';
import { getRelationTables } from '../../utils/util';

const generateKey = () => String(new Date().getTime()).slice(-5) + getSafeRandom().toString(12);

class CardTableModal extends Component {
    render() {
        let { id, stores, configs, pageScope } = this.props,
            store = stores[id],
            { tableId } = store.getCardTableModalInfo(),
            activeTab = stores[tableId].getActiveTab() || tableId,
            config = configs[activeTab],
            {
                sideTitle,
                modalCustomerArea,
                modelClose,
                sideBoxZIndex = 300,
                getPopupContainer,
                setSideBoxClass = () => { },
            } = config,
            locale = store.getLocale(),
            { grandTableMainId, grandGroup } = configs[tableId] || {},
            tablesCount = grandGroup?.length ?? 0,
            { viewIndex } = this.getViewInfo(),
            title = sideTitle?.(viewIndex) || `${locale['table001'] /*'序号'*/} ${viewIndex + 1}`;

        let container = typeof getPopupContainer === 'function' ? getPopupContainer() : document.body,
            position = [window, document, document.body].includes(container) ? 'fixed' : 'absolute';

        return createPortal(<div
            className="card-table-side-box-backdrop"
            onClick={e => {
                if (e.target === e.currentTarget) {
                    store.closeCardTableModal();
                    modelClose?.({ ...pageScope.props, ...pageScope.output }, tableId);
                }
            }}
            style={{ zIndex: sideBoxZIndex, position }}
        >
            <div className={`card-table-side-box ${setSideBoxClass?.()}`} fieldid={getSysFieldid("sidebox_modal-area")}
                onKeyDown={e => {
                    let key = e.keyCode || e.charCode || e.which;

                    if (key == 27 || key == 115) { // f4 esc关闭侧拉
                        store.closeCardTableModal();
                        // 解决快捷键操作情况下，返回时需要聚焦到之前聚焦的单元格上
                        let lastFocusedCell = this.getLastFocusedCell(),
                            focusedCell = this.getFocusedCell();
                        if (focusedCell.rowKey && focusedCell.colKey) {
                            this.focusOnCell(focusedCell.rowKey, focusedCell.colKey);
                        } else if (lastFocusedCell.rowKey && lastFocusedCell.colKey) {
                            this.focusOnCell(lastFocusedCell.rowKey, lastFocusedCell.colKey);
                        }
                    }

                }}
            >
                <div className="side-box-header" fieldid={getSysFieldid("header-area")}>
                    <div className="header-title" fieldid={getSysFieldid(`${title}_title`)}>
                        {title}
                    </div>
                    {this.renderHeaderButtons()}
                </div>
                <div
                    className={classNames(
                        'side-box-body',
                        grandTableMainId || tablesCount === 1
                            ?
                            'nc-bill-tabs-card' // 横向多页签
                            :
                            {
                                'nc-bill-extCard-2': tablesCount === 2, // 一主二子
                                'nc-bill-extCard': tablesCount > 2, // 一主多子
                            },
                    )}
                    tabIndex="0"
                    ref={dom => {
                        this.sideBodyRef = dom;
                    }}
                >
                    {this.renderSubForm()}
                    {this.renderSubTable()}
                    {modalCustomerArea?.()}
                </div>
            </div>
        </div>, container);
    }

    componentDidMount() {
        let { id, stores, configs, relation } = this.props,
            { tableId } = stores[id].getCardTableModalInfo();

        relation.grand[tableId]?.forEach(grandId => {
            configs[grandId].grandComponentDidMount?.();
        });
        // setTimeout(() => {
        //     this.sideBodyRef?.focus();
        // }, 300);
    }

    renderSubForm = () => {
        let { id, stores, relation, pageScope, configs } = this.props,
            store = stores[id],
            meta = pageScope.state.meta,
            { formId, tableId, dataIndex } = store.getCardTableModalInfo(),
            activeTab = stores[tableId].getActiveTab() || tableId,
            { inputChange } = configs[activeTab];

        let { visibleKeys, viewIndex } = this.getViewInfo();

        let formStore = pageScope.formDataSource[formId];

        return <div className='nc-bill-top-area' fieldid={getSysFieldid(`${relation.home[tableId]}_form-area`)}>
            <Form
                key={visibleKeys[viewIndex]}
                store={formStore}
                name={formId}
                config={{
                    onBeforeEvent: this.handleFormBeforeEvent,
                    onAfterEvent: this.handleFormAfterEvent,
                    onCellKeyDown: this.onCellKeyDown,
                    inputChange: (column, value) => {
                        //胡杰李忠博加
                        if (typeof inputChange === 'function') {
                            // 转换一下index
                            return inputChange({ index: dataIndex, item: column, valueChange: value.value });
                        }
                        return true;
                    },
                    getPopupContainer: () => document.querySelector('.side-box-body'),
                }}
                getHotKeyConfig={() => ({
                    pageScope: pageScope,
                    meta,
                    orderOfHotKey: [formId],
                })}
            />
        </div>;
    }

    renderSubTable = () => {
        let { id, stores, configs, pageScope } = this.props,
            store = stores[id],
            { tableId } = store.getCardTableModalInfo(),
            config = configs[tableId],
            { grandTableMainId, grandGroup } = config;

        if (grandTableMainId) {
            Object.entries(configs).forEach(([moduleId, config]) => {
                let { sideBoxZIndex = 300 } = config;
                configs[moduleId] = { maxZIndex: sideBoxZIndex, ...config, fixFooter: false };
            });

            return <BaseCardTable
                {...this.props}
                key={grandTableMainId}
                id={grandTableMainId}
                configs={configs}
                relation={pageScope.tableRelation[grandTableMainId]}
                _tables={getRelationTables.call(this, pageScope.tableRelation[grandTableMainId])}
            />;
        } else {
            return grandGroup?.map(({ grandTableId, grandTableConfig }) => {
                let { sideBoxZIndex = 300 } = grandTableConfig;
                grandTableConfig = { maxZIndex: sideBoxZIndex, ...grandTableConfig, fixFooter: false };
                if (grandGroup?.length === 1) {
                    grandTableConfig.adaptionHeight = true;
                }

                return <BaseCardTable
                    {...this.props}
                    key={grandTableId}
                    id={grandTableId}
                    configs={{ [grandTableId]: grandTableConfig }}
                    relation={pageScope.tableRelation[grandTableId]}
                    _tables={getRelationTables.call(this, pageScope.tableRelation[grandTableId])}
                />;
            });
        }

    }

    renderHeaderButtons = () => {
        let { id, stores, configs, pageScope } = this.props,
            store = stores[id],
            { tableId, formId } = store.getCardTableModalInfo(),
            activeTab = stores[tableId].getActiveTab() || tableId,
            {
                modelFooter,
                hideModelSave,
                modelSave,
                hideAdd,
                modelAddRowBefore,
                hideDel,
                modelDelRowBefore,
                modelClose,
            } = configs[activeTab],
            locale = store.getLocale(),
            status = stores[tableId].getStatus();

        let formStore = pageScope.formDataSource[formId],
            { visibleKeys, viewIndex, row } = this.getViewInfo();

        return <div className="button-wrapper">
            {modelFooter?.({ ...pageScope.props, ...pageScope.output }, tableId, row.dataIndex, row /* , store */)}
            {!hideModelSave && status !== 'browse' && <Button
                onClick={() => {
                    modelSave?.(
                        { ...pageScope.props, ...pageScope.output },
                        row.dataIndex,
                        { tableId },
                        /* index, store */
                    );
                }}
                fieldid="tableModel-save"
            >
                {locale['table004'] /* 整单保存 */}
            </Button>}
            {!hideAdd && status !== 'browse' && <Button
                onClick={async () => {
                    if (typeof modelAddRowBefore === 'function') {
                        let isContinue = await modelAddRowBefore({ ...pageScope.props, ...pageScope.output }, tableId, row.dataIndex);
                        if (isContinue) {
                            this.handleAdd();
                        }
                    } else {
                        this.handleAdd();
                    }
                }}
                fieldid="tableModel-add"
            >
                {locale['table005'] /* 增行 */}
            </Button>}
            {!hideDel && status !== 'browse' && <Button
                onClick={async () => {
                    if (typeof modelDelRowBefore === 'function') {
                        row.values = formStore.getAllFormValue();
                        let isContinue = await modelDelRowBefore({ ...pageScope.props, ...pageScope.output }, tableId, row.dataIndex, row /* , store */);
                        if (isContinue) {
                            this.handleDelete();
                        }
                    } else {
                        this.handleDelete();
                    }
                }}
                fieldid="tableModel-del"
            >
                {locale['table006'] /* 删行 */}
            </Button>}
            {/* 第一页 */}
            <button
                className={classNames("step-button", "first",
                    { 'button-clicked': viewIndex !== 0 },
                )}
                disabled={viewIndex === 0}
                onClick={() => {
                    this.handlePageButtonClick(-Infinity);
                }}
            >
                <i className="icon iconfont icon-shangyiye" />
            </button>
            {/* 上一页 */}
            <button
                className={classNames("step-button",
                    { 'button-clicked': viewIndex !== 0 },
                )}
                disabled={viewIndex === 0}
                onClick={() => {
                    this.handlePageButtonClick(-1);
                }}
            >
                <i className="icon iconfont icon-jiantouzuo" />
            </button>
            {/* 下一页 */}
            <button
                className={classNames("step-button",
                    { 'button-clicked': viewIndex !== visibleKeys.length - 1 },
                )}
                disabled={viewIndex === visibleKeys.length - 1}
                onClick={() => {
                    this.handlePageButtonClick(1);
                }}
            >
                <i className="icon iconfont icon-jiantouyou" />
            </button>
            {/* 最后一页 */}
            <button
                className={classNames("step-button", "last",
                    { 'button-clicked': viewIndex !== visibleKeys.length - 1 },
                )}
                disabled={viewIndex === visibleKeys.length - 1}
                onClick={() => {
                    this.handlePageButtonClick(Infinity);
                }}
            >
                <i className="icon iconfont icon-xiayiye" />
            </button>
            {/* 关闭 */}
            <button
                className={classNames("step-button", "close", 'button-clicked')}
                onClick={() => {
                    document.activeElement?.blur();
                    setTimeout(() => {
                        store.closeCardTableModal();
                        modelClose?.({ ...pageScope.props, ...pageScope.output }, tableId);
                    }, 0);
                }}
            >
                <i className="icon iconfont icon-you icon-celashouqi" />
            </button>
        </div>;
    }

    handlePageButtonClick = step => {
        let { id, stores, configs, pageScope } = this.props,
            store = stores[id],
            { tableId, formId } = store.getCardTableModalInfo(),
            activeTab = stores[tableId].getActiveTab() || tableId,
            { sideRowChange } = configs[activeTab];

        let { visibleKeys, viewIndex } = this.getViewInfo(),
            nextKey;

        viewIndex = Math.min(Math.max(viewIndex + step, 0), visibleKeys.length - 1);
        nextKey = visibleKeys[viewIndex];

        let row = stores[tableId].getRowData(nextKey);

        store.openCardTableModal(tableId, formId, row.dataIndex, pageScope);

        sideRowChange?.(row);
    }

    getViewInfo = () => {
        let { id, stores } = this.props,
            store = stores[id],
            { tableId, dataIndex } = store.getCardTableModalInfo();

        let visibleKeys = stores[tableId].getVisibleRowKeys(),
            rowKeys = stores[tableId].getRowKeys(),
            activeTab = stores[tableId].getActiveTab() || tableId,
            row = stores[activeTab].getRows()[dataIndex];

        return { rowKeys, visibleKeys, viewIndex: row?.viewIndex ?? 0, row };
    }

    handleAdd = () => {
        let { id, stores, configs, pageScope } = this.props,
            store = stores[id],
            { tableId, formId } = store.getCardTableModalInfo(),
            activeTab = stores[tableId].getActiveTab() || tableId,
            config = configs[activeTab],
            { modelAddDefaultValue, modelAddRow } = config,
            { visibleKeys } = this.getViewInfo(),
            key = generateKey();

        let lastRow = stores[tableId].getRowData(visibleKeys[visibleKeys.length - 1]);

        const defaultValue = modelAddDefaultValue?.() || {};
        store.getRelation().share[tableId].forEach(shareId => {
            stores[shareId].addRow(lastRow ? lastRow.dataIndex + 1 : 0, [{ values: defaultValue, key }], { autoFocus: false });
        });

        let visibleRows = stores[tableId].getVisibleRows();
        lastRow = visibleRows[visibleRows.length - 1];

        store.openCardTableModal(tableId, formId, lastRow.dataIndex, pageScope);

        // 侧拉增行后的回调  index 2005给业务组的是上一行的index
        modelAddRow?.call(pageScope, { ...pageScope.props, ...pageScope.output }, tableId, lastRow.dataIndex - 1, { afterAddRowid: lastRow.rowid, ...lastRow });
    }

    handleDelete = () => {
        let { id, stores, configs, pageScope } = this.props,
            store = stores[id],
            { tableId, dataIndex, formId } = store.getCardTableModalInfo(),
            activeTab = stores[tableId].getActiveTab() || tableId,
            { modelDelRow } = stores[activeTab].getConfig() ?? {},
            { visibleKeys, viewIndex } = this.getViewInfo(),
            nextViewIndex = viewIndex + 1,
            checkedKeys = stores[tableId].getCheckedKeys(),
            rowKey = stores[activeTab].getRows()[dataIndex].key;

        // index越界后上移1
        if (viewIndex === visibleKeys.length - 1) {
            nextViewIndex = viewIndex - 1;
        }

        checkedKeys.delete(rowKey);
        stores[tableId].setCheckedKeys(checkedKeys);
        store.getRelation().share[tableId].forEach(shareId => {
            stores[shareId].deleteRow(rowKey);
        });

        if (visibleKeys.length > 1) {
            // 删之前多于1行，删之后不是清空状态
            store.openCardTableModal(tableId, formId, stores[tableId].getRowData(visibleKeys[nextViewIndex]).dataIndex, pageScope);
        } else {
            // 删之后是清空状态
            store.closeCardTableModal();
        }

        modelDelRow?.call(pageScope, { ...pageScope.props, ...pageScope.output }, tableId, { beforeDelRowid: rowKey });
    }

    handleFormBeforeEvent = (moduleId, attrcode, value, values, column) => {
        let { id, configs, stores, pageScope } = this.props,
            store = stores[id],
            { tableId, dataIndex } = store.getCardTableModalInfo(),
            activeTab = stores[tableId].getActiveTab() || tableId,
            { onBeforeEvent } = configs[activeTab],
            { row } = this.getViewInfo(),
            rowKey = stores[activeTab].getRows()[dataIndex].key;

        store.setClickedRow(rowKey);

        if (typeof onBeforeEvent === 'function') {
            console.log('CardTable侧拉编辑前事件', value, column.attrcode, rowKey);
            return handleBeforeEvent.call(pageScope, {
                row,
                column,
                value,
                moduleId: tableId,
                callback: () => {
                    return onBeforeEvent?.(
                        { ...pageScope.props, ...pageScope.output },
                        tableId,
                        column.attrcode,
                        value,
                        row.dataIndex,
                        stores[tableId].getInstance()._formatOutputRow(row),
                        'model',
                    );
                },
                type: 'onCardTableBeforeEvent',
            });
        } else {
            return true;
        }
    }

    handleFormAfterEvent = ({
        attrcode,
        curMetaItem: column,
        value,
        oldValue,
        componentValue,
        event,
    }) => {
        let { id, configs, stores, pageScope, relation } = this.props,
            store = stores[id],
            { share } = relation,
            { tableId, dataIndex, formId } = store.getCardTableModalInfo(),
            activeTab = stores[tableId].getActiveTab() || tableId,
            { onAfterEvent } = configs[activeTab],
            { row } = this.getViewInfo();

        typeof value?.value === 'string' && (value.value = value.value.trim());

        if (column.itemtype === "residtxt") {
            // 多语文本value格式不一样，要特殊处理一下
            Object.entries(value).forEach(([subCode, subValue]) => {
                // 同步单来源的值
                share[tableId].forEach(shareId => {
                    stores[shareId].setCellValue(stores[shareId].getRows()[dataIndex].key, subCode, { value: subValue });
                });
            });
        } else {
            // 同步单来源的值
            share[tableId].forEach(shareId => {
                stores[shareId].setCellValue(stores[shareId].getRows()[dataIndex].key, attrcode, { value });
            });
        }

        console.log('CardTable侧拉编辑后事件', value, oldValue, componentValue, attrcode, dataIndex);
        handleAfterEvent.call(pageScope, {
            row,
            column,
            value,
            oldValue,
            componentValue,
            moduleId: tableId,
            callback: ({ changedRows }) => {
                // handleAfterEvent里更新了数据，这里要同步
                row = stores[tableId].getRowData(row.key);
                return onAfterEvent?.(
                    {
                        ...pageScope.props,
                        ...pageScope.output,
                    },
                    tableId,
                    column.attrcode,
                    column.itemtype === 'refer' || column.itemtype === 'residtxt' ? componentValue : value.value,
                    changedRows,
                    row.dataIndex,
                    stores[tableId].getInstance()._formatOutputRow(row),
                    'model',
                    'change',
                    stores[tableId].getVisibleRows(),
                    event,
                );
            },
            type: 'onCardTableAfterEvent',
            store: stores[tableId],
            formId,
        });
    }

    onCellKeyDown = (attrcode, e) => {
        let { id, configs, stores, pageScope } = this.props,
            store = stores[id],
            { tableId } = store.getCardTableModalInfo(),
            activeTab = stores[tableId].getActiveTab() || tableId,
            { onCellKeyDown } = configs[activeTab],
            { formId } = store.getCardTableModalInfo(),
            { row } = this.getViewInfo();

        if (typeof onCellKeyDown === "function") {
            onCellKeyDown.call(pageScope, { ...pageScope.props, ...pageScope.output }, formId, row, row.viewIndex, attrcode, store.getColumnProps(attrcode), e, 'form');
        }
    }
}

export default CardTableModal;